<template>
    <div class="mt-4 bg-white mx-4">
        <div id="snackbar" class="show" v-if="emes">{{emessage}}</div>
        <div id="snackbar1" class="show" v-if="smes">{{smessage}}</div>

        <div class="row justify-content-center mt-5 card">
            <div class="card-header text-primary">Create Board Agent</div>
            <div class="col-md-8 col-sm-12 card-body offset-2">

                <div class="alert alert-info pb-0" v-if="success">
                    <p>Board Agent's <b>login details</b> was sent to {{formInfo.email}}</p>
                    <button class="btn btn-info mb-2" @click="showInputs()">Create Another Board Agent</button>
                </div>
                
                <div class="mt-5" v-if="!success">
                    <form action="#" @submit.prevent>

                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Email</label>
                                <input class="form-control" type="email" placeholder="Enter your Email" v-model.trim="$v.formInfo.email.$model"  :class="{'is-invalid':$v.formInfo.email.$error, 'is-valid':!$v.formInfo.email.$invalid}">
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Phone Number</label>
                                <input class="form-control" type="text"  placeholder="Enter your phone" v-model.trim="$v.formInfo.phone.$model"  :class="{'is-invalid':$v.formInfo.phone.$error, 'is-valid':!$v.formInfo.phone.$invalid}">
                            </div>
                        </div>
                        <div class="row">
                             <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> City</label>
                                <input class="form-control" type="text"  placeholder="Enter city" v-model.trim="$v.formInfo.city.$model"  :class="{'is-invalid':$v.formInfo.city.$error, 'is-valid':!$v.formInfo.city.$invalid}">
                            </div>
                             <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Address</label>
                                <input class="form-control" type="text"  placeholder="Enter Address" v-model.trim="$v.formInfo.address.$model"  :class="{'is-invalid':$v.formInfo.address.$error, 'is-valid':!$v.formInfo.address.$invalid}">
                            </div>
                        </div>
                        <div class="row">
                            <div  class="col-md-6 col-sm-12 form-group mb-3">
                                <label for="stateCode"><span class="text-danger">*</span>Select a State</label>
                                <select class="form-control" placeholder="Select State" v-model.trim="$v.formInfo.stateCode.$model"  :class="{'is-invalid':$v.formInfo.stateCode.$error, 'is-valid':!$v.formInfo.stateCode.$invalid}">
                                    <option value="" selected>- select a state -</option>
                                    <option v-for="(state, index) in allstates" :value="state.stateCode" :key="index">{{ state.stateName }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label for="tin"><span class="text-danger">*</span>Tax Identification Number</label>
                                <input class="form-control" type="text"  placeholder="Enter your Tax Identification Number" v-model.number="$v.formInfo.taxId.$model"  :class="{'is-invalid':$v.formInfo.taxId.$error, 'is-valid':!$v.formInfo.taxId.$invalid}">
                            </div>
                        </div>

                        <div class="form-group mb-3 mt-4 text-center" v-if="!sending">
                            <button class="btn btn-primary btn-sm px-5" :disabled="$v.formInfo.$invalid || hasVoted == 'true'" type="submit" @click.prevent="signup()"> Create Board Agent </button>
                            </div>
                            <div class="form-group mb-3 text-center" v-if="sending">
                            <button class="btn btn-primary btn-sm px-5" disabled type="submit" > Create Board Agent </button>
                        </div>

                    </form>
                </div>
            </div> <!-- end col -->
        </div>

    </div>
</template>

<script>
import { required, email, minLength} from 'vuelidate/lib/validators'
import { mapState } from 'vuex';

export default {
    name: 'BoardAgentSignup',
    data() {
        return {
            formInfo: {
                email: null,
                phone: null,
                address: null,
                city: null,
                stateAddress: null,
                stateCode: null,
                taxId: null,
            },
            allstates: [],
            emes:false,
            sending:false,
            hasVoted:false,
            smes:false,
            success:false,
        };
    },
    validations: {
        formInfo: {
            email: { required, email },
            phone:{ required, minLength: minLength(9) },
            address:{ required },
            city:{ required },
            stateCode:{ required },
            taxId:{ required },
        }
    },

    mounted(){
        /**
         * Get all states Enrolled
         */
        const stateUrl = `${this.$urlUpload}/statesenrolled`;
        this.$http.get(stateUrl)
        .then(result => {
            if (result.data.data.code == "S200") {
               this.allstates = result.data.data.message
            }
        })
        .catch(err => console.log(err))
    },

    computed:{
        ...mapState(['token'])
    },

    methods:{
        showInputs(){
            this.success = !this.success // display inputs

            // clear the input fields
            for (const input in this.formInfo) {
                if (this.formInfo.hasOwnProperty(input)) {
                    this.formInfo[input] = ''
                }
            }
        },

        signup(){
            this.emes=false;
            this.smes=false;
            // Only send after validations
            this.$v.formInfo.$touch()
            if (this.$v.formInfo.$invalid || this.$v.formInfo.$error) {
                this.emes=true;this.emessage="Please fill the form correctly";
            } else {
                // append stateAddress
                this.formInfo.stateAddress = this.allstates.find(state => state.stateCode == this.formInfo.stateCode).stateName

                // submit logic
                const baseU = `${this.$urlAuth}/createboardagent`;

                this.$http.post(baseU, this.formInfo, {
                    headers:{
                        "x-access-token":this.token
                    }
                })
                .then((result) => {
                    if(result.data.data.code == "S201"){
                        console.log(result.data.data)
                        this.$toastr.s("Account Created Succesfully");

                        this.success = true;

                    }else if(result.data.data.code == "E301"){
                        this.$toastr.e(result.data.data.message[0], 'Error message');
                    }else if(result.data.data.code == "E200"){
                        this.$toastr.e(result.data.data.message, 'Error message');
                    }else{
                        this.$toastr.e("Unexpected Error. Please contact Admin");
                    }
                }).catch(err =>{
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                })
            }
        }
    }
}

</script>